import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'aws-amplify/auth/enable-oauth-listener';
import { configureAmplify } from './amplify-config';
import App from './App';

configureAmplify();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);